import React, {Component} from 'react';
import Modal from 'react-modal';

import {getContentStyles, getOverlayStyles, Title, Subtitle, Button, WrapperButtons} from './styles';

class InfoModal extends Component {
  render() {
    const {
      isDesktop,
      isOpen,
      onClose,
      title,
      subtitle,
      additionalInfo,
      leftButtonText,
      rightButtonText,
      onLeftButtonClick,
      onRightButtonClick
    } = this.props;

    const styles = {
      overlay: getOverlayStyles(),
      content: getContentStyles({isDesktop})
    };

    return (
      <Modal isOpen={isOpen} onRequestClose={onClose} style={styles} ariaHideApp={false} closeTimeoutMS={500}>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        {additionalInfo && <Subtitle>{additionalInfo}</Subtitle>}
        <WrapperButtons>
          {leftButtonText && <Button onClick={onLeftButtonClick}>{leftButtonText}</Button>}
          <Button onClick={onRightButtonClick}>{rightButtonText}</Button>
        </WrapperButtons>
      </Modal>
    );
  }
}

export default InfoModal;
